
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DialogHelper, HttpHelper } from 'nglhelper';
import { catchError } from 'rxjs/operators'

@Injectable()
export class FormLoader {

    constructor(private http: HttpHelper, private dialog: DialogHelper) {

    }
    isShow = false;
    Get$(url: string) {
        return this.http.Get$(url)
            .pipe(catchError((err)=> {
                var msg = err;
                if (err instanceof Error) {
                    msg = err.message;
                }
                if (this.isShow)
                    return;

                this.isShow = true;
                this.dialog.ShowMessageDialog({
                    title: "Form Error",
                    titleColor: '#E91E63',
                    message: "Unable to load form data. " + msg,
                    icon: 'error',
                    buttons: [{ Id: 1, Name: 'Back' }, { Id: 2, Name: 'Reload' }]
                })
                    .subscribe((res: any) => {
                        this.isShow = false;
                        if (res == 1) {
                            window.history.back();
                        }
                        else
                            window.location.reload();

                    })

                return observableThrowError(err);
            }));
    }

    Get(url: string) {
        return this.Get$(url).toPromise();
    }




}